document.addEventListener("DOMContentLoaded", function() {
  var btn = document.getElementById('BLBackTop');

  window.onscroll = function() {
    if (document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
      btn.style.visibility = "visible";
      btn.style.opacity = "1";
    } else {
      btn.style.visibility = "hidden";
      btn.style.opacity = "0";
    }
  };

  // Scroll to the top when the button is clicked
  btn.addEventListener('click', function() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  });
});
